import { useEffect, useState } from "react";
import EulaDefault from "../users/EULADefault";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const Eula = () => {
    const [eulaBox, setEulaBox] = useState(null);

    useEffect(() => {
        const initializeEula = async () => {
            try {
                const customEula = await import(
                    "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/users/EULA");

                setEulaBox(customEula.default());
            } catch {
                setEulaBox(<EulaDefault />);
            }
        };
        initializeEula();
    }, []);

    return <div>{eulaBox}</div>;
};
export default Eula;